import { MDCDialog } from "@material/dialog";

let adminDialogLinksBound = false;

export function initAdminDialogLinks() {
  if (adminDialogLinksBound) return;
  adminDialogLinksBound = true;

  document.addEventListener("click", function(event) {
    const closeButton = event.target instanceof Element && event.target.closest(".dialog-close-button");
    if (!closeButton) return;

    const dialogShell = closeButton.closest(".mdc-dialog-shell");
    if (dialogShell == null) return;
    if (dialogShell.matches(".mdc-dialog-shell[data-controller*='dialog']")) return;

    const hasTrackedForm = dialogShell.dataset.dialogHasTrackedForm === "true";
    const isDirty = dialogShell.dataset.dialogDirty === "true";
    if (hasTrackedForm && isDirty) return;

    event.preventDefault();
    event.stopPropagation();
    dialogShell.remove();
  }, true);

  document.addEventListener("click", function(event) {
    const action = event.target instanceof Element && event.target.closest("[data-dialog-close-on-click='true']");
    if (action == null) return;

    const dialogEl = action.closest(".mdc-dialog");
    dialogEl?.MDCDialog?.close();

    if (action.dataset.dialogCloseParentOnClick !== "true") return;

    document.querySelectorAll(".mdc-dialog-shell[data-dialog-transient='true']").forEach(function(dialogShell) {
      if (dialogShell.contains(action)) return;

      const parentDialog = dialogShell.querySelector(".mdc-dialog");
      if (parentDialog?.MDCDialog) {
        parentDialog.MDCDialog.close();
      } else {
        dialogShell.remove();
      }
    });
  }, true);

  document.addEventListener("click", function(event) {
    const link = event.target.closest("a.popup_link");
    if (link == null) return;
    if (!window.location.pathname.startsWith("/admin")) return;
    if (link.dataset.method != null || link.dataset.turboMethod != null || link.dataset.confirm != null) return;

    if (link.classList.contains("close_confirm")) {
      event.preventDefault();
      openConfirmationDialog();
      return;
    }

    const href = link.getAttribute("href");
    if (href == null || href.length === 0) return;

    if (href.startsWith("#")) {
      const dialogEl = document.querySelector(href);
      if (dialogEl == null) return;

      event.preventDefault();
      openExistingDialog(dialogEl);
      return;
    }

    event.preventDefault();
    openRemoteDialog(href, link);
  }, true);

}

function openRemoteDialog(url, link) {
  fetch(url, {
    credentials: "same-origin",
    headers: {
      Accept: "text/html, application/xhtml+xml",
      "X-Requested-With": "XMLHttpRequest",
    },
  }).then(function(response) {
    if (!response.ok) {
      window.location = url;
      return null;
    }

    return response.text();
  }).then(function(html) {
    if (html == null) return;

    openDialogHtml(html);
  }).catch(function() {
    window.location = url;
  });
}

function openDialogHtml(html) {
    const wrapper = document.createElement("div");
    wrapper.innerHTML = html;
    const dialogShell = wrapper.firstElementChild;

    if (dialogShell == null) {
      return;
    }

    dialogShell.dataset.dialogTransient = "true";
    document.body.appendChild(dialogShell);

    if (dialogShell.dataset.rtl === "true") {
      dialogShell.classList.add("rtl");
      dialogShell.setAttribute("dir", "rtl");
    }

    if (window.mdcAutoInit) window.mdcAutoInit(dialogShell);

    const dialogEl = dialogShell.querySelector(".mdc-dialog");
    if (dialogEl == null) {
      dialogShell.remove();
      return;
    }

    const dialog = dialogEl.MDCDialog || new MDCDialog(dialogEl);
    dialogEl.MDCDialog = dialog;
    wireReadOnlyCloseButtons(dialogShell, dialog);
    dialogEl.addEventListener("turbo:submit-end", function(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.dataset.dialogCloseOnSuccess !== "true") return;
      if (event.detail?.success !== true) return;

      dialog.close();
    });
    dialogEl.addEventListener("click", function(event) {
      const action = event.target instanceof Element && event.target.closest("[data-dialog-close-on-click='true']");
      if (action != null) dialog.close();
    });
    dialog.listen("MDCDialog:closed", function() {
      if (dialogShell.dataset.dialogTransient === "true") dialogShell.remove();
    });
    dialog.open();
}

function openExistingDialog(dialogEl) {
  const dialogShell = dialogEl.classList.contains("mdc-dialog-shell") ? dialogEl : dialogEl.closest(".mdc-dialog-shell") || dialogEl;
  const dialogNode = dialogShell.querySelector(".mdc-dialog") || dialogShell;
  dialogShell.classList.remove("mfp-hide");
  dialogNode.classList.remove("mfp-hide");

  const dialog = dialogNode.MDCDialog || new MDCDialog(dialogNode);
  dialogNode.MDCDialog = dialog;
  wireReadOnlyCloseButtons(dialogShell, dialog);
  dialog.open();
}

function openIframeDialog(link) {
  const href = link.getAttribute("href");
  if (href == null || href.length === 0) return;

  const title = link.textContent.trim() || "Preview";
  const dialogId = `iframe-dialog-${Date.now()}`;
  const dialogEl = document.createElement("div");
  dialogEl.className = "mdc-dialog mdc-dialog--fullscreen";
  dialogEl.id = dialogId;
  dialogEl.innerHTML = `
    <div class="mdc-dialog__container">
      <div class="mdc-dialog__surface max-864">
        <div class="mdc-dialog__header">
          <div class="mdc-dialog__title">${escapeHtml(title)}</div>
        </div>
        <div class="mdc-dialog__content">
          <div style="position: relative; width: 100%; padding-top: 56.25%;">
            <iframe
              src="${escapeHtml(href)}"
              title="${escapeHtml(title)}"
              style="position: absolute; inset: 0; width: 100%; height: 100%; border: 0;"
              allow="autoplay; fullscreen; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <div class="mdc-dialog__actions">
          <div class="flex justify-end">
            <button class="mdc-button mdc-button--unelevated mdc-button--outlined medium grey-outlined dialog-close-button" type="button">
              <span class="mdc-button__ripple"></span>
              <span class="mdc-button__label">Close</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="mdc-dialog__scrim"></div>
  `;

  document.body.appendChild(dialogEl);
  if (window.mdcAutoInit) window.mdcAutoInit(dialogEl);

  const dialog = dialogEl.MDCDialog || new MDCDialog(dialogEl);
  dialogEl.MDCDialog = dialog;
  dialog.listen("MDCDialog:closed", function() {
    dialogEl.remove();
  });
  dialog.open();
}

function openConfirmationDialog() {
  const template = document.querySelector("#close-confirmation-dialog-template");
  if (template == null) return;

  const wrapper = document.createElement("div");
  wrapper.innerHTML = template.innerHTML;
  const dialogEl = wrapper.firstElementChild;
  if (dialogEl == null) return;

  document.body.appendChild(dialogEl);
  if (window.mdcAutoInit) window.mdcAutoInit(dialogEl);

  const dialog = dialogEl.MDCDialog || new MDCDialog(dialogEl);
  dialogEl.MDCDialog = dialog;

  const closeDialog = function() {
    dialog.close();
    dialogEl.remove();
  };

  dialogEl.querySelector(".confirmation-dialog__button--discard")?.addEventListener("click", closeDialog);
  dialogEl.querySelector(".confirmation-dialog__button--continue")?.addEventListener("click", closeDialog);
  dialog.open();
}

function wireReadOnlyCloseButtons(dialogShell, dialog) {
  if (dialogShell.querySelector(".dialog-submit-form") != null) return;

  dialogShell.querySelectorAll(".dialog-close-button").forEach(function (button) {
    button.addEventListener("click", function(event) {
      event.preventDefault();
      dialogShell.remove();
    });
  });

  dialog.listen("MDCDialog:closed", function() {
    dialogShell.remove();
  });
}

function escapeHtml(text) {
  return text
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}
